module.exports = __webpack_public_path__ + "img/apple-app-store-badge.c71a29fa.png";